import { useStateSelector } from '../store/selectors';
import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { USER_ROLES } from '../utils/constants';
import { isViewAsBuyerActive } from '../utils/viewAsBuyer';

export const useCurrentMarketplaceParty = (engagementId?: number): TimelineParty => {
    const summary = useStateSelector((s) => s.userSummary.summary);
    const currentUser = useStateSelector((s) => s.currentUser.user);
    const currentTimeline = useStateSelector((s) => s.timelines.currentTimeline);

    if (isViewAsBuyerActive()) {
        return TimelineParty.Buyer;
    }

    if (
        engagementId &&
        currentUser?.id &&
        currentTimeline?.id === engagementId &&
        currentTimeline?.engagementProcess?.userId === currentUser.id
    ) {
        return TimelineParty.Seller;
    }

    if (engagementId && summary?.engagements) {
        const engagement = summary.engagements.find((e: any) => e.id === engagementId);
        if (engagement && engagement.party !== undefined) {
            return engagement.party;
        }
    }

    if (summary?.isMarketplaceBuyer) {
        return TimelineParty.Buyer;
    }
    if (summary?.roleId === USER_ROLES.ADMIN) {
        return TimelineParty.VetValue;
    }
    // The broker flag is global — it says the user advises somewhere, not that they advise on
    // *this* engagement. Only trust it when no engagement was named, otherwise a seller who is
    // also a broker gets classified Broker on their own engagement. Per-engagement resolution
    // happens above (owned timeline, then the server-resolved party on summary.engagements).
    if (summary?.isMarketplaceBroker && !engagementId) {
        return TimelineParty.Broker;
    }
    return TimelineParty.Seller;
};
